import { GetCulpritAdjusterImageTabsAlertsQueryParamType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritAdjusterImageTabsAlerts/getCulpritAdjusterImageTabsAlertsQuery.type';
import { getCulpritAdjusterImageTabsAlertsQueryFunctions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritAdjusterImageTabsAlerts/getCulpritAdjusterImageTabsAlertsQueryFunctions';
import { queryOptions } from '@tanstack/react-query';

const getCulpritAdjusterImageTabsAlertsQueryOptions = (
  params: GetCulpritAdjusterImageTabsAlertsQueryParamType,
) =>
  queryOptions({
    queryKey: ['GET_CULPRIT_IMAGE_TABS_ALERTS', params],
    queryFn: () => getCulpritAdjusterImageTabsAlertsQueryFunctions(params),
  });
export default getCulpritAdjusterImageTabsAlertsQueryOptions;
